import { filter, map, Observable, withLatestFrom } from 'rxjs';
import { EpicDeps } from 'src/core/engine';
import { ofType } from 'src/core/engine/rxjs/ofType';

import { AppendState } from '../cart.reducer';
import { CartMsg } from '../cart.actions';

export function clearMessages(
    action$: Observable<any>,
    state$: Observable<AppendState>,
    deps: EpicDeps,
): Observable<any> {
    const msgCount$ = state$.pipe(
        map((s) => s?.cart),
        map((cart) => cart.messages.length + Object.keys(cart.itemMessages).length),
    );
    return action$.pipe(
        ofType(deps.LOCATION_CHANGE),
        withLatestFrom(msgCount$),
        filter(([, msgCount]) => msgCount > 0),
        map(() => CartMsg('Cart.ClearAllItemMessages')),
    );
}
